import React from 'react';

import { client } from '@admin/libraries/apollo';
import { useFormattedAppointmentLaborAgreementQuery } from '@admin/schema';

export const LaborPolicy: React.FC<{ orderId: string }> = ({ orderId }) => {
  const { data } = useFormattedAppointmentLaborAgreementQuery({ variables: { orderId }, client });

  return <span> {data?.formattedAppointmentLaborAgreement} </span>;
};
